import { state } from "scripts/app";
import { map } from "scripts/map/map";
import { MessageToast } from "scripts/ui/components/toast";

export class MarkerControls {
    btn: HTMLButtonElement;
    
    constructor(){
        const setMarkerBtn = document.getElementById('setMarkerBtn');
        if(!(setMarkerBtn instanceof HTMLButtonElement)) {throw new Error("Ошибка! Кнопка установки маркера не найдена")};

        this.btn = setMarkerBtn;
        this.addEventListener();
    }

    private addEventListener(){
        this.btn.addEventListener('click', () => this.setMarker());
    }

    private setMarker(){
        if(!state.detector){ MessageToast.showDanger("1", "Сначала выберите или создайте датчик"); return;}
            
        if (state.detector.lng && state.detector.lat)
            map.easeTo({ center: [state.detector.lng, state.detector.lat], zoom: 14 });
    }
}